<template>
  <v-layout
    v-if="dialog && cartQty > 0 && promoItems.length > 0"
    row
    justify-center
  >
    <v-dialog
      :value.sync="dialog"
      persistent
      :fullscreen="(menuItemDialog && !(iOS && inIframe))"
      max-width="528"
    >
      <div
        class="modal__header"
        :style="myHeaderStyle"
      >
        <v-layout
          row
          align-center
        >
          <v-flex xs10>
            <span
              :style="myTitleStyle"
              class="name"
            >{{ $t('today_special') }}</span>
          </v-flex>
          <v-flex
            xs2
            mr-1
            text-xs-right
          >
            <v-btn
              icon
              :color="theme.toolbar_color"
              flat
              @click="dialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
      <div
        class="modal__content"
        :style="myContentStyle"
      >
        <carousel
          v-model="carouselIndex"
          :perPage="1"
          paginationEnabled
          :paginationColor="theme.toolbar_bg_color"
          :paginationActiveColor="theme.toolbar_color"
          :paginationPadding="3"
          :paginationSize="6"
          :style="myCarouselStyle"
        >
          <slide
            v-for="(promoItem, index) in promoItems"
            :key="index"
          >
            <v-card
              flat
              :style="myCardStyle"
            >
              <v-card-text>
                <div
                  class="cat-item mb-1"
                  :style="myMenuStyle"
                >
                  <v-layout
                    row
                    align-center
                  >
                    <v-avatar
                      :size="$mq === 'xs' ? '110' : '140'"
                      tile
                    >
                      <img class="food-img" :src="itemImage(promoItem.photo_url)">
                    </v-avatar>
                    <v-flex ml-3>
                      <v-layout
                        row
                        align-center
                      >
                        <v-flex xs12>
                          <span :style="myNameStyle">{{ itemName(promoItem) }}</span>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs12>
                          <span :style="myPriceStyle(promoItem)">{{ $n(promoItem.price, 'currency') }}</span>
                          <span
                            v-if="priceLower(promoItem)"
                            :style="myDiscountStyle"
                          >{{ $n(promoItem.price_override, 'currency') }}</span>
                        </v-flex>
                      </v-layout>
                      <span v-if="requirements(promoItem).length > 0">
                      <v-layout
                        v-for="(requirement, index) in requirements(promoItem)"
                        :key="index"
                        row
                      >
                        <v-flex
                          xs12
                          class="text-xs-left"
                        >
                          <span :style="fulfilledStyle(requirement.fulfilled)">{{ requirement.text }}</span>
                          <v-icon
                            class="middle"
                            small
                            :color="fulfilledIcon(requirement.fulfilled).color"
                          >{{ fulfilledIcon(requirement.fulfilled).icon }}</v-icon>
                        </v-flex>
                      </v-layout>
                      </span>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-text>
            </v-card>
          </slide>
        </carousel>
        <v-btn
          block
          class="btn pl-0 pr-0 text-xs-center"
          :color="theme.btn_color_secondary"
          :disabled="btnDisabled"
          :dark="!btnDisabled || dark"
          @click="addToCart"
        >
          <v-layout row>
            <v-flex
              xs12
              class="text-xs-center nowrap-text"
            >{{ $t('add_to_cart') }}</v-flex>
          </v-layout>
        </v-btn>
        <v-btn
          v-if="btnDisabled && !isMember && allowLogin"
          block
          class="btn pl-0 pr-0 text-xs-center"
          :color="theme.btn_color_secondary"
          :dark="btnDisabled || dark"
          @click="register"
        >
          <v-layout row>
            <v-flex
              xs12
              class="text-xs-center nowrap-text"
            >{{ $t('signup') }}</v-flex>
          </v-layout>
        </v-btn>
      </div>
      <menu-item-dialog v-if="menuItemDialog && !(iOS && inIframe)" from-promo-items-dialog />
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { Carousel, Slide } from 'vue-carousel'
import MenuItemDialog from '~/components/MenuItemDialog'

export default {
  name: 'promo-items',
  components: {
    'carousel': Carousel,
    'slide': Slide,
    'menu-item-dialog': MenuItemDialog
  },
  data () {
    return {
      dialog: false,
      carouselIndex: 0
    }
  },
  computed: {
    ...mapGetters('auth', [
      'authenticated'
    ]),
    ...mapGetters('config', [
      'theme', 'iOS', 'inIframe', 'config', 'mode', 'language', 'modes', 'allowLogin'
    ]),
    ...mapGetters('cart', [
      'cart', 'cartQty', 'cartAmount', 'itemQtyInCart', 'cartLimitReached'
    ]),
    ...mapGetters('menu', [
      'menuItemDialog'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    ...mapGetters('promo', [
      'promoItems'
    ]),
    dark () {
      return parseInt(this.theme.main_menu_theme) === 1
    },
    myContainerStyle () {
      return {
        padding: '5px 0px 5px 5px'
      }
    },
    myHeaderStyle () {
      return {
        backgroundColor: this.theme.toolbar_bg_color
      }
    },
    myTitleStyle () {
      return {
        color: this.theme.toolbar_color
      }
    },
    myMenuStyle () {
      return {
        color: this.theme.cart_name_color,
        position: 'relative',
      }
    },
    myNameStyle () {
      return {
        fontSize: '16px',
        fontWeight: 700
      }
    },
    myDiscountStyle () {
      return {
        fontSize: '16px',
        verticalAlign: 'middle'
      }
    },
    myContentStyle () {
      return {
        backgroundColor: this.theme.bg_color
      }
    },
    myCardStyle () {
      let styles = {
        marginLeft: '-7px',
        marginRight: '-7px',
        backgroundColor: this.theme.bg_color
      }
      // Only style for pagination dots
      if (this.promoItems.length > 1) {
        styles.marginBottom = '-18px'
      }
      return styles
    },
    myCarouselStyle () {
      return {
        backgroundColor: this.theme.bg_color
      }
    },
    carouselPromoItem () {
      return this.promoItems[this.carouselIndex]
    },
    btnDisabled () {
      if (this.carouselPromoItem && this.requirements(this.carouselPromoItem).find(r => !r.fulfilled)) {
        return true
      }
      return false
    }
  },
  methods: {
    requirements (item) {
      const req = []
      const dineModes = []
      const promoSetting = item.promo_setting
      // Allowed dinemodes
      JSON.parse(promoSetting.dine_modes).forEach(d => {
        const mode = this.modes.find(m => m.dineMode === d)
        if (mode) dineModes.push(mode.name)
      })
      if (dineModes.length > 0) {
        req.push({
          text: dineModes.join(', '),
          fulfilled: dineModes.includes(this.mode.name)
        })
      }
      // Member-only promo
      if (parseInt(promoSetting.member_only) === 1) {
        req.push({
          text: 'Member only',
          fulfilled: this.isMember ? true : false
        })
      }
      // Minimum spending
      if (parseFloat(promoSetting.min_spend) > 0) {
        req.push({
          text: 'Min. spend $' + parseFloat(promoSetting.min_spend).toFixed(2),
          fulfilled: this.cartAmount >= parseFloat(promoSetting.min_spend)
        })
      }
      return req
    },
    fulfilledIcon (fulfilled) {
      return {
        icon: fulfilled ? 'fas fa-check' : 'fas fa-times',
        color: fulfilled ? this.theme.orders_success_color : this.theme.orders_fail_color
      }
    },
    fulfilledStyle (fulfilled) {
      let styles = {
        fontSize: '14px',
      }
      if (fulfilled) {
        styles.color = this.theme.orders_success_color
      } else {
        styles.color = this.theme.orders_fail_color
      }
      return styles
    },
    myPriceStyle (item) {
      let styles = {
        fontSize: '16px',
        verticalAlign: 'middle'
      }
      if (this.priceLower(item)) {
        styles.textDecoration = 'line-through'
      }
      return styles
    },
    priceLower (item) {
      return parseFloat(item.price_override) < parseFloat(item.price)
    },
    itemImage (photoUrl) {
      return photoUrl ? photoUrl : window.config.sharedPictures + 'food_image.png'
    },
    itemName (item) {
      const multiplePlus = this.promoItems.find(c => c.item_id === item.item_id && c.plu_id !== item.plu_id) ? true : false
      let name
      if (this.language !== 'en-SG') {
        name = item.alternate_name || item.name
        if (multiplePlus) name += ' (' + (item.portion_size_alternatename ? item.portion_size_alternatename : item.portion_size_name) + ')'
      } else {
        name = item.name
        if (multiplePlus) name += ' (' + item.portion_size_name + ')'
      }
      return name
    },
    async addToCart () {
      const item = this.promoItems[this.carouselIndex]
      if (item.courses && item.courses.length > 0) {
        if (item.price_override) {
          item.final_price = parseFloat(item.price_override)
        }
        this.$store.dispatch('menu/showMenuItemDialog', item)
      } else {
        if (this.cartLimitReached(item.plu_id)) {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            title: 'Unable to add',
            text: this.$t('error_cart_limit'),
            modal: true
          })
          return
        }

        let special_req_cats = JSON.parse(this.config.special_request_cats)
        if (parseInt(this.config.enable_special_request) === 2 && special_req_cats.length > 0 && special_req_cats.includes(item.category_id)) {
          this.$store.dispatch('menu/showMenuItemDialog', item)
        } else {
          const params = {
            item: JSON.parse(JSON.stringify(item)),
            quantity: 1,
            final_price: parseFloat(item.price_override || item.price),
            is_promo: true
          }
          await this.$store.dispatch('cart/addCartItem', params)

          this.$store.dispatch('responseMessage', {
            type: 'success',
            text: this.$t('successfully_added_item'),
            timeout: 1800
          })
        }
      }
    },
    register () {
      if (this.authenticated) {
        this.$router.push({ name: 'register2' })
      } else {
        this.$router.push({ name: 'register' })
      }
    },
  },
  async beforeMount () {
    const vm = this
    this.$bus.$on('showPromoItemsDialog', (payload) => { vm.dialog = payload })
    // await this.$store.dispatch('promo/fetchPromoItems')
    // this.$bus.$on('showPromoItemsDialog', (payload) => { vm.dialog = payload })
  },
  async mounted () {
    await this.$store.dispatch('promo/fetchPromoItems')
    if (this.mode.isDinein) {
      this.dialog = true
    }
  },
  beforeDestroy () {
    this.$bus.$off('showPromoItemsDialog')
  }
}
</script>

<style scoped>
.modal__header {
  height: 48px;
}
.modal__content {
  width: 100%;
  overflow-y: auto;
  padding: 8px 10px;
}
.loading-background {
  background-color: rgba(255, 255, 255, 0.4);
}
.important-note {
  font-size: 19px;
}
.name {
  padding-left: 16px;
}
.middle {
  padding: 3px;
}
.food-img {
  border-radius: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/PromoItemsDialog.vue